// Shared ENERGY STAR readiness UI components (badges + filter pills).
import { READINESS_META, SCORE_ELIG_META, READINESS_FILTERS, filterCount } from './readiness';

export function ReadinessBadge({ status, className = '' }) {
  const m = READINESS_META[status] || READINESS_META.needs_attention;
  const { Icon } = m;
  return (
    <span
      className={`inline-flex items-center gap-1 border rounded-none px-2 py-0.5 text-[11px] font-semibold ${m.cls} ${className}`}
      data-testid={`readiness-badge-${status}`}
    >
      <Icon className="h-3 w-3" /> {m.label}
    </span>
  );
}

export function ScoreEligibilityBadge({ value, className = '' }) {
  if (!value) return null;
  const m = SCORE_ELIG_META[value] || SCORE_ELIG_META.none;
  const { Icon } = m;
  return (
    <span
      className={`inline-flex items-center gap-1 border rounded-none px-2 py-0.5 text-[10px] font-medium ${m.cls} ${className}`}
      title={m.tip}
      data-testid={`score-elig-${value}`}
    >
      <Icon className="h-3 w-3" /> {m.label}
    </span>
  );
}

export function ReadinessFilters({ counts, active, onChange, testidPrefix = 'esr' }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={`${testidPrefix}-readiness-filters`}>
      {READINESS_FILTERS.map((f) => {
        const n = filterCount(counts, f.key);
        const on = active === f.key;
        return (
          <button
            key={f.key}
            onClick={() => onChange(f.key)}
            data-testid={`${testidPrefix}-filter-${f.key}`}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold border rounded-none transition-colors ${
              on ? 'bg-foreground text-background border-foreground' : 'bg-card text-muted-foreground border-border hover:text-foreground'
            }`}
          >
            {f.label}
            <span className={`tabular-nums text-[10px] px-1 rounded-none ${on ? 'bg-background/20' : 'bg-muted text-muted-foreground'}`}>{n}</span>
          </button>
        );
      })}
    </div>
  );
}
